import { Component, Inject, OnInit, SimpleChanges } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef,
} from '@angular/material/dialog';
import { AddProductService } from '@app/add-product/add-product.service';
import { IDropDownOption } from '@app/add-product/models/multiselect-model';
import { SetsService } from '@app/sets/services/sets.service';
import * as CONSTANT from '../../../sets/set-details/set-details.constant';
import { VariantGridDataService } from '@app/@core/services/variant-grid-data/variant-grid-data.service';
import {
    ISelectedVariants,
    ISetDetailsData,
    IVariantGridData,
    IVariantModelData,
} from '@app/add-product/models/variant-grid-data-model';
import { DeleteSetVariantsDialogComponent } from '@app/sets/delete-set-variants/delete-set-variants-dialog.component';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CopySetSnackbarMessageComponent } from '@app/add-product/pages/add-product/components/copy-set-snackbar-message/copy-set-snackbar-message.component';
import { SellerPortalEventBrokerService } from '@app/@core/services/event-broker/seller-portal-event-broker.service';
import { SetSelectedTabEventBroker } from '@app/sets/services/event-broker/set-selected-panel-broker';
import { AppToastrService } from '@app/@core/services/toastr/app-toastr.service';
import * as _ from 'lodash';

@Component({
    selector: 'sp-variant-modal',
    templateUrl: './variant-modal.component.html',
    styleUrls: ['./variant-modal.component.scss'],
    providers: [VariantGridDataService],
})
export class VariantModalComponent implements OnInit {
    public hardCodedColors: Array<IDropDownOption> = [
        { value: '#624637', label: 'Bronze' },
        { value: '#663300', label: 'Brown' },
        { value: '#FFD700', label: 'Gold' },
        { value: '#5788F7', label: 'Blue' },
        { value: '#080808', label: 'Black' },
        { value: '#ff7b00', label: 'Orange' },
        { value: '#F75757', label: 'Red' },
        { value: '#cac8c4', label: 'Silver' },
        { value: '#ffaaaa', label: 'Pink' },
        { value: '#FFFFFF', label: 'White' },
        { value: '#9f9ea2', label: 'Metallic' },
        { value: 'none', label: 'Transparent' },
        { value: '#f2e7bf', label: 'Beige' },
        { value: '#5a005a', label: 'Purple' },
        { value: '#F7C657', label: 'Yellow' },
        { value: '#f8f8ff', label: 'Off-White' },
        { value: '#40e0d0', label: 'Turquoise' },
        { value: '#61C920', label: 'Green' },
        { value: '#FFFDD0', label: 'Cream' },
        { value: '#800000', label: 'Maroon' },
        { value: '#808080', label: 'Grey' },
        { value: '#D2B48C', label: 'Tan' },
        { value: '#FFE5B4', label: 'Peach' },
        { value: '#808000', label: 'Olive' },
        { value: '#e7bd42', label: 'Golden' },
        { value: '#36454F', label: 'Charcoal' },
        { value: '#000080', label: 'Navy Blue' },
        { value: '#4a2c2a', label: 'Coffee Brown' },
        { value: 'multicolor', label: 'Multi-Coloured' },
    ];
    public sizes: Array<IDropDownOption> = [];
    public isFootwearCat: boolean = false;
    public variantKeys = {
        color: 'color',
        size: 'size',
    };
    public colors: Array<IDropDownOption> = [];
    public selectedFootwearCatSizeOption: string;
    public sizeOptionList: Array<string> = new Array<string>();
    public sizeMasterData: any = {};
    public isVariantsDeleted: boolean = false;
    public deleteTimedoutId: NodeJS.Timeout;
    public isVariantsUpdated: boolean = false;
    public updateTimedoutId: NodeJS.Timeout;
    selectedColorsSubscription: Subscription;
    selectedSizesSubscription: Subscription;
    variantGridTableDataSubscription: Subscription;
    variantGridTableData: Array<IVariantGridData> =[];
    selectedColors: Array<IDropDownOption>;
    selectedSizes: Array<IDropDownOption>;
    showColorErrMsg: boolean = false;
    showSizeErrMsg: boolean = false;
    isColorDropdownClicked: boolean = false;
    isSizeDropdownClicked: boolean = false;
    sumofQunatity: number = 0;
    public selectedSizeType: any;
    variantAttributesList: any;
    productAttributesList: any;
    productInfoSubscription: any;
    additionalPropertiesDetails: any;
    isApparelCategory = false;
    theme = "size";
    mapping = {size: 'Size',ageSize: 'Age/Size'}
    constructor(
        public dialogRef: MatDialogRef<VariantModalComponent>,
        @Inject(MAT_DIALOG_DATA) public variantModalData: IVariantModelData,
        public setsService: SetsService,
        public variantGridDataService: VariantGridDataService,
        private _snackBar: MatSnackBar,
        private dialog: MatDialog,
        private eventBroker: SellerPortalEventBrokerService,
        private addProductService: AddProductService,
        private toasterService: AppToastrService
    ) {}

    ngOnInit(): void {
        this.isApparelCategory = this.addProductService.isApparelCategory
        this.variantAttributesList = this.setsService.getVariantAttributes();
        this.productInfoSubscription = this.setsService.getProductAttributes();
        console.log("productInfoSubscription", this.productInfoSubscription);
        this.productAttributesList = this.setsService.getProductAttributesMaster();
        this.additionalPropertiesDetails=this.setsService.getAdditionalPropertiesDetails();
        this.selectedSizeType=this.productInfoSubscription?.finalPayload?.attributes?.sizeType;
        this.checkIsFootwearCategory();
        this.setSizedata();
        this.populateColors();
        this.selectedColorsSubscription = this.variantGridDataService
            .getSelectedColorsObservable()
            .subscribe((selectedColors: Array<IDropDownOption>) => {
                this.selectedColors = selectedColors;
                this.showColorErrMsg = !this.selectedColors.length;
            });
        this.selectedSizesSubscription = this.variantGridDataService
            .getSelectedSizesObservable()
            .subscribe((selectedSizes: Array<IDropDownOption>) => {
                this.selectedSizes = selectedSizes;
                this.showSizeErrMsg = !this.selectedSizes.length;
            });
        this.variantGridDataService.getSelectedSizesObservable();
        if (this.variantModalData.mode) {
            this.variantGridDataService.setVariantData([
                ...this.setsService.selectedVaraintsList[
                    this.variantModalData.index
                ].variants,
            ]);
        }
        this.variantGridTableDataSubscription = this.variantGridDataService
            .getUpdatedVariantGridDataObservable()
            .subscribe((variantGridTableData: Array<IVariantGridData>) => {
                this.variantGridTableData = variantGridTableData;
                this.sumofQunatity = this.variantGridTableData.reduce(
                    (acc: number, variantGridData: IVariantGridData) =>
                        acc + +variantGridData.quantity,
                    0
                );
            });
    }
    ngOnChanges(sc : SimpleChanges){

      }
    checkIsFootwearCategory() {
        let selectedCategory = this.setsService.getCategorySelection();
        let relativeCatPath = this.setsService.getRelativeCategoryPath();
        if (!selectedCategory && !relativeCatPath) {
            selectedCategory = this.addProductService.getCategorySelection();
            relativeCatPath = this.addProductService.getRelativeCategoryPath();
        }

        if (
            selectedCategory &&
            selectedCategory.category === CONSTANT.FOOTWEAR_CATEGORY_ID
        ) {
            this.isFootwearCat = true;
            this.variantKeys = {
                color: 'footwearColor',
                size: 'footwearSize',
            };
            this.selectedFootwearCatSizeOption =
                relativeCatPath.split('/')[0] + ' size';
        }
    }
    // setSizedata() {
    //     const sizeData = this.isFootwearCat
    //         ? this.setsService.getFootwearSizes()
    //         : this.setsService.getSizes();
    //     console.log("size data is", sizeData)
    //     this.sizeOptionList = this.isFootwearCat
    //         ? [this.selectedFootwearCatSizeOption]
    //         : Object.keys(sizeData);
    //     console.log("size option list is",this.sizeOptionList);
    //     this.sizeOptionList.forEach((option) => {
    //         this.sizeMasterData[option] = [];
    //         sizeData[option].forEach((element) => {
    //             this.sizeMasterData[option].push({
    //                 displayName: element,
    //                 state: false,
    //             });
    //         });
    //     });
    //     console.log("size master data", this.sizeMasterData);
    //     for (let key in this.sizeMasterData) {
    //         if (Array.isArray(this.sizeMasterData[key])) {
    //             this.sizeMasterData[key].forEach((element) => {
    //                 this.sizes.push({
    //                     value: element.displayName,
    //                     label: element.displayName,
    //                 });
    //             });
    //         }
    //     }
    //     console.log("this.sizes", this.sizes);
    // }

    // new code for set sizes
    setSizedata() {
        if (this.isFootwearCat) {
            this.setFootwearSizesFromSchema();
        }
        else if(this.isApparelCategory) {
            this.setApparelSizeFromSchema()
        }
        else {
            const sizeData = this.setsService.getSizes();
            this.sizeOptionList = Object.keys(sizeData);
            this.sizeOptionList.forEach((option) => {
                this.sizeMasterData[option] = [];
                sizeData[option].forEach((element) => {
                    this.sizeMasterData[option].push({
                        displayName: element,
                        state: false,
                    });
                });
            });
            for (let key in this.sizeMasterData) {
                if (Array.isArray(this.sizeMasterData[key])) {
                    this.sizeMasterData[key].forEach((element) => {
                        this.sizes.push({
                            value: element.displayName,
                            label: element.displayName,
                        });
                    });
                }
            }
        }
    }

    showDeletedAlert(showAlert: boolean): void {
        this.isVariantsDeleted = showAlert;
        this.deleteTimedoutId = setTimeout(() => {
            this.isVariantsDeleted = false;
        }, 5000);
    }

    showUpdatedAlert(showAlert: boolean): void {
        this.isVariantsUpdated = showAlert;
        this.updateTimedoutId = setTimeout(() => {
            this.isVariantsUpdated = false;
        }, 5000);
    }

    closeDeleteAlertAction(): void {
        clearTimeout(this.deleteTimedoutId);
        this.isVariantsDeleted = false;
    }

    closeUpdateAlertAction(): void {
        clearTimeout(this.updateTimedoutId);
        this.isVariantsUpdated = false;
    }

    close(): void {
        this.dialogRef.close();
    }

    saveSetVariants(): void {
        if (this.selectedColors.length && this.selectedSizes.length) {
            if (this.variantModalData.mode) {
                const selectedVariants: ISelectedVariants = _.cloneDeep(
                    this.setsService.selectedVaraintsList[
                        this.variantModalData.index
                    ]
                );
                selectedVariants.variants =
                    this.variantGridDataService.getVariantData();
                if (
                    this.setsService.checkDuplicateSetVariants(
                        selectedVariants,
                        this.variantModalData
                    )
                ) {
                    this.toasterService.error(
                        'This variant exists. Please add new variant.'
                    );
                    this.dialogRef.close();
                    return;
                }
                this.setsService.selectedVaraintsList[
                    this.variantModalData.index
                ] = selectedVariants;
            } else {
                const setDetailsData: ISetDetailsData = {
                    setDetailsForm:
                        this.setsService.createSetDetailsFormGroup(),
                    isEditMode: false,
                    reviewErrors: {},
                };
                const selectedVariants: ISelectedVariants = {
                    variantId: '',
                    variants: this.variantGridDataService.getVariantData(),
                    setDetailsData: setDetailsData,
                    isPanelExpanded: false,
                    variantImages: [],
                    isEditable: true,
                    campaignAssociated: false,
                };
                if (
                    this.setsService.checkDuplicateSetVariants(selectedVariants)
                ) {
                    this.toasterService.error(
                        'This variant exists. Please add new variant.'
                    );
                    this.dialogRef.close();
                    return;
                }
                const message = 'New variant created sucessfully';
                this.setsService.selectedVaraintsList.push(selectedVariants);
                this._snackBar.openFromComponent(
                    CopySetSnackbarMessageComponent,
                    {
                        duration: 3000,
                        data: {
                            message: message,
                        },
                        horizontalPosition: 'center',
                        verticalPosition: 'top',
                        panelClass: ['copy-snackbar'],
                    }
                );
                this.eventBroker.publish(
                    new SetSelectedTabEventBroker('newVariantAdded')
                );
            }
            this.setsService.selectedVaraintsList = [
                ...this.setsService.selectedVaraintsList,
            ];
            this.dialogRef.close();
        }
    }

    deleteSetVariants(): void {
        const deleteVariantdialogRef = this.dialog.open(
            DeleteSetVariantsDialogComponent,
            {
                data: {},
                width: '35%',
                panelClass: 'variant-dialog-container',
            }
        );
        deleteVariantdialogRef.afterClosed().subscribe((val) => {
            if (val) {
                this.setsService.selectedVaraintsList =
                    this.setsService.selectedVaraintsList.filter(
                        (item: ISelectedVariants, itemIndex: number) =>
                            itemIndex != this.variantModalData.index
                    );
                this.eventBroker.publish(
                    new SetSelectedTabEventBroker('deletedSetVariant')
                );
                this.dialogRef.close();
            }
        });
    }

    onColorDropdownClicked(isColorDropdownClicked: boolean) {
        this.isColorDropdownClicked = isColorDropdownClicked;
    }
    onSizeDropdownClicked(isSizeDropdownClicked: boolean) {
        this.isSizeDropdownClicked = isSizeDropdownClicked;
    }

    enableSaveBtn(): boolean {
        const allQuantityCheck: boolean =
            this.variantGridTableData.filter(
                (rowData: IVariantGridData) => rowData.quantity
            ).length === this.variantGridTableData.length;
        return (
            this.selectedColors?.length > 0 &&
            this.selectedSizes?.length > 0 &&
            allQuantityCheck
        );
    }

    ngOnDestroy(): void {
        this.selectedColorsSubscription.unsubscribe();
        this.selectedSizesSubscription.unsubscribe();
    }
    populateColors() {
        if (this.isFootwearCat || this.isApparelCategory) {
            this.colors = this.additionalPropertiesDetails.color.metaData
                .filter(color => color.displayable)
                .map(color => ({ value:color.title=='Assorted'?'#Multi-color':color.code, label: color.title }));
        } else {
            this.colors = [...this.hardCodedColors];
        }
    }
    setFootwearSizesFromSchema() {
        // Find the metadata for the selected size type
        const selectedSizeTypeMeta = this.additionalPropertiesDetails.sizeType.metaData.find(sizeType => sizeType.parent === this.selectedSizeType);
        if (selectedSizeTypeMeta) {
            selectedSizeTypeMeta.metaData.forEach(size => {
                this.sizes.push({
                    value: size.value,
                    label: size.value });
            });
        }
    }
    setApparelSizeFromSchema() {
        if(this.additionalPropertiesDetails.ageSize) {
            this.theme = 'ageSize'
        } else {
            this.theme = 'size'
        }
        this.addProductService.apparelTheme = this.theme
        const selectedSizeType = this.additionalPropertiesDetails?.[this.theme]?.enum
            if (selectedSizeType) {
                selectedSizeType?.forEach(size => {
                    this.sizes.push({
                        value: size,
                        label: size });
                });
            }
    }
}
